import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';

const DEFAULT_MESSAGE_ID = 'common.userManualInfoTooltip';
const DEFAULT_MESSAGE_PREFIX_ID = 'common.userManualInfoTooltipPrefix';
const DEFAULT_MESSAGE_SUFFIX_ID = 'common.userManualInfoTooltipSuffix';
const DEFAULT_MESSAGE = 'Klikom na ovakvu istu ikonicu u gornjem desnom uglu stranice, mozete pogledati detaljnije o ovom dijelu sistema na korisnickom uputstvu.';
const DEFAULT_MESSAGE_PREFIX = 'Klikom na ikonicu';
const DEFAULT_MESSAGE_SUFFIX = 'u gornjem desnom uglu stranice, mozete pogledati detaljnije o ovom dijelu sistema na korisnickom uputstvu.';

const InfoCircleManualTooltip = ({
    intl,
    messageId,
    messagePrefixId,
    messageSuffixId,
    defaultMessage,
    defaultMessagePrefix,
    defaultMessageSuffix,
    position,
    size,
    color,
    className,
    style,
    iconStyle,
    disabled
}) => {
    const content = intl.formatMessage({ id: messageId, defaultMessage });
    const contentPrefix = intl.formatMessage({ id: messagePrefixId, defaultMessage: defaultMessagePrefix });
    const contentSuffix = intl.formatMessage({ id: messageSuffixId, defaultMessage: defaultMessageSuffix });
    const popupContent = (
        <span>
            {contentPrefix}
            {' '}
            <Icon name="info circle" color="grey" />
            {' '}
            {contentSuffix}
        </span>
    );
    const trigger = (
        <span
            aria-label={content}
            className={className}
            role="img"
            style={{ cursor: 'help', display: 'inline-block', ...style }}
            tabIndex={0}
        >
            <Icon name="info circle" color={color} size={size} style={iconStyle} />
        </span>
    );

    return (
        <Popup
            content={popupContent}
            disabled={disabled}
            hideOnScroll
            position={position}
            trigger={trigger}
        />
    );
};

InfoCircleManualTooltip.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    messageId: PropTypes.string,
    messagePrefixId: PropTypes.string,
    messageSuffixId: PropTypes.string,
    defaultMessage: PropTypes.string,
    defaultMessagePrefix: PropTypes.string,
    defaultMessageSuffix: PropTypes.string,
    position: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    iconStyle: PropTypes.object,
    disabled: PropTypes.bool
};

InfoCircleManualTooltip.defaultProps = {
    messageId: DEFAULT_MESSAGE_ID,
    messagePrefixId: DEFAULT_MESSAGE_PREFIX_ID,
    messageSuffixId: DEFAULT_MESSAGE_SUFFIX_ID,
    defaultMessage: DEFAULT_MESSAGE,
    defaultMessagePrefix: DEFAULT_MESSAGE_PREFIX,
    defaultMessageSuffix: DEFAULT_MESSAGE_SUFFIX,
    position: 'bottom right',
    size: 'large',
    color: 'blue',
    className: '',
    style: {},
    iconStyle: {},
    disabled: false
};

export default injectIntl(InfoCircleManualTooltip);



// WEBPACK FOOTER //
// ./src/components/InfoCircleManualTooltip/InfoCircleManualTooltip.js